<template>
  <div>
    <h6 v-if="allTags.length > 0" class="text-secondary fw-bold">{{ $t('network.filterByMediaType') }}</h6>
    <treeselect
      v-if="allTags.length > 0"
      id="tag_query"
      :key="tagSearchKey"
      data-test="tag_query"
      :options="options"
      :option-label="customLabel"
      :v-model="selectedTags"
      :placeholder="$t('TagSearch.type-to-search-available-tags')"
      :multiple="true"
      @input="inputEventFromSelect"
      @search="onSearch"
    >
    </treeselect>
  </div>
</template>
<script>
import { debounce, sortBy } from 'lodash';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: { 
    Treeselect,
  },
  props: {
    networkSlug: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, Array],
      default: null,
    },
    inCourseFeed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      tagSearchString: null,
      topTags: [],
      allTags: [],
      options: [],
      selectedTags: [],
      tagSearchKey: 0,
    };
  },
  computed: {
    baseSearchUrl() {
      let url = '';
      if (this.networkSlug){
        url += 'tags?network=' + this.networkSlug + '&limit=6';
      } else if (this.inCourseFeed) {
        url += 'tags';
      } else {
        url += 'tags?withMediaCount&limit=6&hasMedia';
      } 
      return url;
    },
  },
  mounted() {
    this.loadTopTags();
    this.loadAllTags();
    this.$bus.on('reset-tag-filter', () => {
      this.tagSearchKey++;
    });
  },
  methods: {
    loadTopTags() {
      this.$http.get(this.baseSearchUrl).then(resp => {
        this.topTags = resp.data;
      });
    },
    loadAllTags() {
      this.loading = true;
      this.$http.get(this.networkSlug ? 'tags?network=' + this.networkSlug : this.inCourseFeed ? 'tags' : ('tags?withMediaCount&hasMedia')).then(resp => {
        if (this.inCourseFeed) {
          this.allTags = sortBy(resp.data).reverse()
            .map(option => ({ ...option, id: option.id || '', label: option.name, isTopTags: false }));
        } else {
          this.allTags = sortBy(resp.data, [(option) => (option.combined_count || 0)]).reverse()
            .map(option => ({ ...option, id: option.id || '', label: this.customLabel(option), isTopTags: false }));
        }
        this.options = this.allTags;
      }).then(() => {
        this.loading = false;
      });
    },
    onSearch: debounce(function (search) {
      this.loading = true;
      if(search.length == 0) {
        this.options = this.allTags;
        this.loading = false;
        return;
      }
      let url = this.baseSearchUrl + '&query=' + search;

      this.$http.get(url).then(resp => {
        this.options = [];
        this.options = sortBy(resp.data, ['combined_count']).reverse();
      }).then(() => {
        this.loading = false;
      });
    }, 600),
    customLabel(option) {
      return `${option.name} ${option.combined_count !== 0 ? '(' + option.combined_count + ')' : '(0)'}`;
    },
    inputEventFromSelect(selectedIds) {
      const selectedElements = this.allTags.filter(option => selectedIds.includes(option.id));
      this.$emit('input', selectedElements);
    },
  },
};
</script>
<style>
.vue-treeselect__control {
  height: 48px !important;
  border: none;
  box-shadow: 0 0 0.625rem -0.1875rem rgb(0 0 0 / 13%) !important;
}
.vue-treeselect__placeholder, .vue-treeselect__single-value, .vue-treeselect__input {
  top: 7px !important;
  padding-left: 1rem !important;
  font-size: 1rem !important;
}
.vue-treeselect__placeholder {
  color: #a9a9a9 !important;
}
.vue-treeselect__multi-value-label {
  padding-left: 5px;
  font-size: 1rem !important;
  font-weight: 400 !important;
}
</style>